import { DtoState } from '../types'

import { DtoAction, DtoReducerAction } from './actionTypes'

export const dtoReducer = (state: DtoState, action: DtoAction): DtoState => {
  switch (action.type) {
    case DtoReducerAction.CHANGE_DTO: {
      return { ...state, ...action.payload.dtos }
    }
    default:
      return state
  }
}
